// extracted by mini-css-extract-plugin
export default {"loginForm":"style_loginForm__VM2F5","wrapper":"style_wrapper__nl8jC","form":"style_form__oRMOv","image":"style_image__WCEu0"};